const data={
  FacturasRecibidas: [
    {
      PendientePago: 0,
      TotalImpuestos: 0,
      Importe: 0,
      Total: 0,
      Fecha: 'string'
    }
  ],
  Proveedores: [
    {
      Nombre: 'string',
      Total: 0
    }
  ],
  blnError: true,
  codError: 'string',
  msgError: 'string'
}

export default data
